import { Pipe, PipeTransform } from "@angular/core";
import { AppConsts } from "../../AppConsts";

@Pipe({
    standalone: false,
    name: "dateFormatJs",
})
export class DateFormatJsPipe implements PipeTransform {
    transform(date: Date): string {
        if (!date) {
            return "";
        }

        let dateFormat = AppConsts.dateFormatList?.find((r) => r.id === AppConsts.dateFormatId)?.name || "DD/MM/YYYY";
        const dateFormatArray = dateFormat.split("/");
        let dateArray = dateFormatArray.map((r) => {
            if (r === "MM") {
                return (date.getMonth() + 1) < 10 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1);
            } else if (r === "DD") {
                return date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
            } else if (r === "YYYY") {
                return date.getFullYear();
            }
        });
        return dateArray.join("/");
    }
}
